export const MONTHS_SHORT = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

/**
 * Períodos tributarios YYYYMM para poblar selects, desde el mes actual hacia
 * atrás. La mayoría de módulos SUNAT (declaraciones, deudas, detracciones,
 * cuenta-control, etc.) solo ofrecen datos confiables de los últimos años, por
 * eso el default es acotado — pero cualquier período fuera de este rango sigue
 * siendo válido y se ingresa con `PeriodSelect` vía el formulario "Otro período".
 */
export function buildPeriodOptions(yearsBack = 5): { value: string; label: string }[] {
  const now  = new Date();
  const curY = now.getFullYear();
  const curM = now.getMonth() + 1;
  const opts: { value: string; label: string }[] = [];
  for (let y = curY; y >= curY - yearsBack; y--) {
    const maxM = y === curY ? curM : 12;
    for (let m = maxM; m >= 1; m--) {
      opts.push({
        value: `${y}${String(m).padStart(2, '0')}`,
        label: `${MONTHS_SHORT[m - 1]} ${y}`,
      });
    }
  }
  return opts;
}

export const PERIOD_OPTIONS = buildPeriodOptions();

export function formatPeriodoLabel(yyyymm: string): string {
  const y = yyyymm.slice(0, 4);
  const m = parseInt(yyyymm.slice(4), 10);
  return `${MONTHS_SHORT[m - 1] ?? ''} ${y}`.trim();
}
